import * as THREE from "three";
import { useEffect, useRef } from "react";
import { REACT_APP_BACKEND_URL } from "../../../config";

const clock = new THREE.Clock();

let timestamp: number | null = null;

export const useDayNightCycle = (listener: ({
  time,
  daynightCycle
}: {
  time: number;
  daynightCycle: number;
}) => void) => {
  const interval = useRef<number | null>(null);

  useEffect(() => {
    const dateTime = new Date();

    const evaluateDayNightCycle = () => {
      if (timestamp === null) {
        return;
      }

      const time = clock.getElapsedTime();
      dateTime.setTime(timestamp + time * 1000.0);

      const daynightCycle = (Math.abs(dateTime.getUTCHours() - 12) / 12 - 0.5) * 2.0;
      listener({ time, daynightCycle });
    };

    if (timestamp !== null) {
      evaluateDayNightCycle();
    }

    fetch(`${REACT_APP_BACKEND_URL}/time/`, { method: 'GET' })
    .then(async (response) => {
      if (response.status !== 200) {
        throw new Error();
      }

      return await response.json();
    })
    .then(data => {
      timestamp = data as number;
    })
    .catch(() => {
      timestamp = Date.now();
    })
    .finally(() => {
      if (interval.current) {
        clearInterval(interval.current);
      }

      interval.current = setInterval(evaluateDayNightCycle, 60 * 1000) as unknown as number;
      evaluateDayNightCycle();
    });

    return () => {
      if (interval.current) {
        clearInterval(interval.current);
      }
    };
  }, []);
};
